/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as ManagerRouteImport } from './routes/_manager'
import { Route as GuestRouteImport } from './routes/_guest'
import { Route as ImpersonateTokenRouteImport } from './routes/impersonate/$token'
import { Route as ManagerVerifyUpdatedEmailRouteImport } from './routes/_manager/verify-updated-email'
import { Route as ManagerSettingsRouteImport } from './routes/_manager/settings'
import { Route as ManagerLogoutRouteImport } from './routes/_manager/logout'
import { Route as ManagerCustomerPortalRouteImport } from './routes/_manager/customer-portal'
import { Route as ManagerAdminRouteImport } from './routes/_manager/admin'
import { Route as ManagerSetupRouteImport } from './routes/_manager/_setup'
import { Route as ManagerAppRouteImport } from './routes/_manager/_app'
import { Route as GuestVerifyEmailRouteImport } from './routes/_guest/verify-email'
import { Route as GuestRegisterRouteImport } from './routes/_guest/register'
import { Route as GuestRecoverPasswordRouteImport } from './routes/_guest/recover-password'
import { Route as GuestLoginRouteImport } from './routes/_guest/login'
import { Route as GuestForgotPasswordRouteImport } from './routes/_guest/forgot-password'
import { Route as ManagerAppIndexRouteImport } from './routes/_manager/_app/index'
import { Route as ManagerSetupSubscriptionPastDueRouteImport } from './routes/_manager/_setup/subscription-past-due'
import { Route as ManagerSetupCreateFirstBrandRouteImport } from './routes/_manager/_setup/create-first-brand'
import { Route as ManagerSetupChooseSubscriptionRouteImport } from './routes/_manager/_setup/choose-subscription'
import { Route as ManagerAppSubscriptionRouteImport } from './routes/_manager/_app/subscription'
import { Route as ManagerAppCreatorsIndexRouteImport } from './routes/_manager/_app/creators/index'
import { Route as ManagerAppCollaborationsIndexRouteImport } from './routes/_manager/_app/collaborations/index'
import { Route as ManagerAppCampaignsIndexRouteImport } from './routes/_manager/_app/campaigns/index'
import { Route as ManagerAppBrandsIndexRouteImport } from './routes/_manager/_app/brands/index'
import { Route as ManagerAppCampaignsReportsRouteImport } from './routes/_manager/_app/campaigns/reports'
import { Route as ManagerAppCampaignsCreateRouteImport } from './routes/_manager/_app/campaigns/create'
import { Route as ManagerAppBrandsCreateRouteImport } from './routes/_manager/_app/brands/create'
import { Route as ManagerAppCreatorsIdIndexRouteImport } from './routes/_manager/_app/creators/$id/index'
import { Route as ManagerAppCollaborationsIdIndexRouteImport } from './routes/_manager/_app/collaborations/$id/index'
import { Route as ManagerAppCampaignsIdIndexRouteImport } from './routes/_manager/_app/campaigns/$id/index'
import { Route as ManagerAppCollaborationsIdMessagesRouteImport } from './routes/_manager/_app/collaborations/$id/messages'
import { Route as ManagerAppCampaignsIdUpdateRouteImport } from './routes/_manager/_app/campaigns/$id/update'
import { Route as ManagerAppCampaignsIdReportRouteImport } from './routes/_manager/_app/campaigns/$id/report'
import { Route as ManagerAppBrandsIdUpdateRouteImport } from './routes/_manager/_app/brands/$id/update'

const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagerRoute = ManagerRouteImport.update({
  id: '/_manager',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestRoute = GuestRouteImport.update({
  id: '/_guest',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateTokenRoute = ImpersonateTokenRouteImport.update({
  id: '/impersonate/$token',
  path: '/impersonate/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagerVerifyUpdatedEmailRoute =
  ManagerVerifyUpdatedEmailRouteImport.update({
    id: '/verify-updated-email',
    path: '/verify-updated-email',
    getParentRoute: () => ManagerRoute,
  } as any)
const ManagerSettingsRoute = ManagerSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ManagerRoute,
} as any)
const ManagerLogoutRoute = ManagerLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => ManagerRoute,
} as any)
const ManagerCustomerPortalRoute = ManagerCustomerPortalRouteImport.update({
  id: '/customer-portal',
  path: '/customer-portal',
  getParentRoute: () => ManagerRoute,
} as any)
const ManagerAdminRoute = ManagerAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ManagerRoute,
} as any)
const ManagerSetupRoute = ManagerSetupRouteImport.update({
  id: '/_setup',
  getParentRoute: () => ManagerRoute,
} as any)
const ManagerAppRoute = ManagerAppRouteImport.update({
  id: '/_app',
  getParentRoute: () => ManagerRoute,
} as any)
const GuestVerifyEmailRoute = GuestVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => GuestRoute,
} as any)
const GuestRegisterRoute = GuestRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => GuestRoute,
} as any)
const GuestRecoverPasswordRoute = GuestRecoverPasswordRouteImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => GuestRoute,
} as any)
const GuestLoginRoute = GuestLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => GuestRoute,
} as any)
const GuestForgotPasswordRoute = GuestForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => GuestRoute,
} as any)
const ManagerAppIndexRoute = ManagerAppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManagerAppRoute,
} as any)
const ManagerSetupSubscriptionPastDueRoute =
  ManagerSetupSubscriptionPastDueRouteImport.update({
    id: '/subscription-past-due',
    path: '/subscription-past-due',
    getParentRoute: () => ManagerSetupRoute,
  } as any)
const ManagerSetupCreateFirstBrandRoute =
  ManagerSetupCreateFirstBrandRouteImport.update({
    id: '/create-first-brand',
    path: '/create-first-brand',
    getParentRoute: () => ManagerSetupRoute,
  } as any)
const ManagerSetupChooseSubscriptionRoute =
  ManagerSetupChooseSubscriptionRouteImport.update({
    id: '/choose-subscription',
    path: '/choose-subscription',
    getParentRoute: () => ManagerSetupRoute,
  } as any)
const ManagerAppSubscriptionRoute = ManagerAppSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => ManagerAppRoute,
} as any)
const ManagerAppCreatorsIndexRoute = ManagerAppCreatorsIndexRouteImport.update({
  id: '/creators/',
  path: '/creators/',
  getParentRoute: () => ManagerAppRoute,
} as any)
const ManagerAppCollaborationsIndexRoute =
  ManagerAppCollaborationsIndexRouteImport.update({
    id: '/collaborations/',
    path: '/collaborations/',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppCampaignsIndexRoute =
  ManagerAppCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppBrandsIndexRoute = ManagerAppBrandsIndexRouteImport.update({
  id: '/brands/',
  path: '/brands/',
  getParentRoute: () => ManagerAppRoute,
} as any)
const ManagerAppCampaignsReportsRoute =
  ManagerAppCampaignsReportsRouteImport.update({
    id: '/campaigns/reports',
    path: '/campaigns/reports',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppCampaignsCreateRoute =
  ManagerAppCampaignsCreateRouteImport.update({
    id: '/campaigns/create',
    path: '/campaigns/create',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppBrandsCreateRoute = ManagerAppBrandsCreateRouteImport.update({
  id: '/brands/create',
  path: '/brands/create',
  getParentRoute: () => ManagerAppRoute,
} as any)
const ManagerAppCreatorsIdIndexRoute =
  ManagerAppCreatorsIdIndexRouteImport.update({
    id: '/creators/$id/',
    path: '/creators/$id/',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppCollaborationsIdIndexRoute =
  ManagerAppCollaborationsIdIndexRouteImport.update({
    id: '/collaborations/$id/',
    path: '/collaborations/$id/',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppCampaignsIdIndexRoute =
  ManagerAppCampaignsIdIndexRouteImport.update({
    id: '/campaigns/$id/',
    path: '/campaigns/$id/',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppCollaborationsIdMessagesRoute =
  ManagerAppCollaborationsIdMessagesRouteImport.update({
    id: '/collaborations/$id/messages',
    path: '/collaborations/$id/messages',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppCampaignsIdUpdateRoute =
  ManagerAppCampaignsIdUpdateRouteImport.update({
    id: '/campaigns/$id/update',
    path: '/campaigns/$id/update',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppCampaignsIdReportRoute =
  ManagerAppCampaignsIdReportRouteImport.update({
    id: '/campaigns/$id/report',
    path: '/campaigns/$id/report',
    getParentRoute: () => ManagerAppRoute,
  } as any)
const ManagerAppBrandsIdUpdateRoute =
  ManagerAppBrandsIdUpdateRouteImport.update({
    id: '/brands/$id/update',
    path: '/brands/$id/update',
    getParentRoute: () => ManagerAppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/not-found': typeof NotFoundRoute
  '/forgot-password': typeof GuestForgotPasswordRoute
  '/login': typeof GuestLoginRoute
  '/recover-password': typeof GuestRecoverPasswordRoute
  '/register': typeof GuestRegisterRoute
  '/verify-email': typeof GuestVerifyEmailRoute
  '/admin': typeof ManagerAdminRoute
  '/customer-portal': typeof ManagerCustomerPortalRoute
  '/logout': typeof ManagerLogoutRoute
  '/settings': typeof ManagerSettingsRoute
  '/verify-updated-email': typeof ManagerVerifyUpdatedEmailRoute
  '/impersonate/$token': typeof ImpersonateTokenRoute
  '/subscription': typeof ManagerAppSubscriptionRoute
  '/choose-subscription': typeof ManagerSetupChooseSubscriptionRoute
  '/create-first-brand': typeof ManagerSetupCreateFirstBrandRoute
  '/subscription-past-due': typeof ManagerSetupSubscriptionPastDueRoute
  '/': typeof ManagerAppIndexRoute
  '/brands/create': typeof ManagerAppBrandsCreateRoute
  '/campaigns/create': typeof ManagerAppCampaignsCreateRoute
  '/campaigns/reports': typeof ManagerAppCampaignsReportsRoute
  '/brands': typeof ManagerAppBrandsIndexRoute
  '/campaigns': typeof ManagerAppCampaignsIndexRoute
  '/collaborations': typeof ManagerAppCollaborationsIndexRoute
  '/creators': typeof ManagerAppCreatorsIndexRoute
  '/brands/$id/update': typeof ManagerAppBrandsIdUpdateRoute
  '/campaigns/$id/report': typeof ManagerAppCampaignsIdReportRoute
  '/campaigns/$id/update': typeof ManagerAppCampaignsIdUpdateRoute
  '/collaborations/$id/messages': typeof ManagerAppCollaborationsIdMessagesRoute
  '/campaigns/$id': typeof ManagerAppCampaignsIdIndexRoute
  '/collaborations/$id': typeof ManagerAppCollaborationsIdIndexRoute
  '/creators/$id': typeof ManagerAppCreatorsIdIndexRoute
}
export interface FileRoutesByTo {
  '/not-found': typeof NotFoundRoute
  '/forgot-password': typeof GuestForgotPasswordRoute
  '/login': typeof GuestLoginRoute
  '/recover-password': typeof GuestRecoverPasswordRoute
  '/register': typeof GuestRegisterRoute
  '/verify-email': typeof GuestVerifyEmailRoute
  '/admin': typeof ManagerAdminRoute
  '/customer-portal': typeof ManagerCustomerPortalRoute
  '/logout': typeof ManagerLogoutRoute
  '/settings': typeof ManagerSettingsRoute
  '/verify-updated-email': typeof ManagerVerifyUpdatedEmailRoute
  '/impersonate/$token': typeof ImpersonateTokenRoute
  '/subscription': typeof ManagerAppSubscriptionRoute
  '/choose-subscription': typeof ManagerSetupChooseSubscriptionRoute
  '/create-first-brand': typeof ManagerSetupCreateFirstBrandRoute
  '/subscription-past-due': typeof ManagerSetupSubscriptionPastDueRoute
  '/': typeof ManagerAppIndexRoute
  '/brands/create': typeof ManagerAppBrandsCreateRoute
  '/campaigns/create': typeof ManagerAppCampaignsCreateRoute
  '/campaigns/reports': typeof ManagerAppCampaignsReportsRoute
  '/brands': typeof ManagerAppBrandsIndexRoute
  '/campaigns': typeof ManagerAppCampaignsIndexRoute
  '/collaborations': typeof ManagerAppCollaborationsIndexRoute
  '/creators': typeof ManagerAppCreatorsIndexRoute
  '/brands/$id/update': typeof ManagerAppBrandsIdUpdateRoute
  '/campaigns/$id/report': typeof ManagerAppCampaignsIdReportRoute
  '/campaigns/$id/update': typeof ManagerAppCampaignsIdUpdateRoute
  '/collaborations/$id/messages': typeof ManagerAppCollaborationsIdMessagesRoute
  '/campaigns/$id': typeof ManagerAppCampaignsIdIndexRoute
  '/collaborations/$id': typeof ManagerAppCollaborationsIdIndexRoute
  '/creators/$id': typeof ManagerAppCreatorsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_guest': typeof GuestRouteWithChildren
  '/_manager': typeof ManagerRouteWithChildren
  '/not-found': typeof NotFoundRoute
  '/_guest/forgot-password': typeof GuestForgotPasswordRoute
  '/_guest/login': typeof GuestLoginRoute
  '/_guest/recover-password': typeof GuestRecoverPasswordRoute
  '/_guest/register': typeof GuestRegisterRoute
  '/_guest/verify-email': typeof GuestVerifyEmailRoute
  '/_manager/_app': typeof ManagerAppRouteWithChildren
  '/_manager/_setup': typeof ManagerSetupRouteWithChildren
  '/_manager/admin': typeof ManagerAdminRoute
  '/_manager/customer-portal': typeof ManagerCustomerPortalRoute
  '/_manager/logout': typeof ManagerLogoutRoute
  '/_manager/settings': typeof ManagerSettingsRoute
  '/_manager/verify-updated-email': typeof ManagerVerifyUpdatedEmailRoute
  '/impersonate/$token': typeof ImpersonateTokenRoute
  '/_manager/_app/subscription': typeof ManagerAppSubscriptionRoute
  '/_manager/_setup/choose-subscription': typeof ManagerSetupChooseSubscriptionRoute
  '/_manager/_setup/create-first-brand': typeof ManagerSetupCreateFirstBrandRoute
  '/_manager/_setup/subscription-past-due': typeof ManagerSetupSubscriptionPastDueRoute
  '/_manager/_app/': typeof ManagerAppIndexRoute
  '/_manager/_app/brands/create': typeof ManagerAppBrandsCreateRoute
  '/_manager/_app/campaigns/create': typeof ManagerAppCampaignsCreateRoute
  '/_manager/_app/campaigns/reports': typeof ManagerAppCampaignsReportsRoute
  '/_manager/_app/brands/': typeof ManagerAppBrandsIndexRoute
  '/_manager/_app/campaigns/': typeof ManagerAppCampaignsIndexRoute
  '/_manager/_app/collaborations/': typeof ManagerAppCollaborationsIndexRoute
  '/_manager/_app/creators/': typeof ManagerAppCreatorsIndexRoute
  '/_manager/_app/brands/$id/update': typeof ManagerAppBrandsIdUpdateRoute
  '/_manager/_app/campaigns/$id/report': typeof ManagerAppCampaignsIdReportRoute
  '/_manager/_app/campaigns/$id/update': typeof ManagerAppCampaignsIdUpdateRoute
  '/_manager/_app/collaborations/$id/messages': typeof ManagerAppCollaborationsIdMessagesRoute
  '/_manager/_app/campaigns/$id/': typeof ManagerAppCampaignsIdIndexRoute
  '/_manager/_app/collaborations/$id/': typeof ManagerAppCollaborationsIdIndexRoute
  '/_manager/_app/creators/$id/': typeof ManagerAppCreatorsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/not-found'
    | '/forgot-password'
    | '/login'
    | '/recover-password'
    | '/register'
    | '/verify-email'
    | '/admin'
    | '/customer-portal'
    | '/logout'
    | '/settings'
    | '/verify-updated-email'
    | '/impersonate/$token'
    | '/subscription'
    | '/choose-subscription'
    | '/create-first-brand'
    | '/subscription-past-due'
    | '/'
    | '/brands/create'
    | '/campaigns/create'
    | '/campaigns/reports'
    | '/brands'
    | '/campaigns'
    | '/collaborations'
    | '/creators'
    | '/brands/$id/update'
    | '/campaigns/$id/report'
    | '/campaigns/$id/update'
    | '/collaborations/$id/messages'
    | '/campaigns/$id'
    | '/collaborations/$id'
    | '/creators/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/not-found'
    | '/forgot-password'
    | '/login'
    | '/recover-password'
    | '/register'
    | '/verify-email'
    | '/admin'
    | '/customer-portal'
    | '/logout'
    | '/settings'
    | '/verify-updated-email'
    | '/impersonate/$token'
    | '/subscription'
    | '/choose-subscription'
    | '/create-first-brand'
    | '/subscription-past-due'
    | '/'
    | '/brands/create'
    | '/campaigns/create'
    | '/campaigns/reports'
    | '/brands'
    | '/campaigns'
    | '/collaborations'
    | '/creators'
    | '/brands/$id/update'
    | '/campaigns/$id/report'
    | '/campaigns/$id/update'
    | '/collaborations/$id/messages'
    | '/campaigns/$id'
    | '/collaborations/$id'
    | '/creators/$id'
  id:
    | '__root__'
    | '/_guest'
    | '/_manager'
    | '/not-found'
    | '/_guest/forgot-password'
    | '/_guest/login'
    | '/_guest/recover-password'
    | '/_guest/register'
    | '/_guest/verify-email'
    | '/_manager/_app'
    | '/_manager/_setup'
    | '/_manager/admin'
    | '/_manager/customer-portal'
    | '/_manager/logout'
    | '/_manager/settings'
    | '/_manager/verify-updated-email'
    | '/impersonate/$token'
    | '/_manager/_app/subscription'
    | '/_manager/_setup/choose-subscription'
    | '/_manager/_setup/create-first-brand'
    | '/_manager/_setup/subscription-past-due'
    | '/_manager/_app/'
    | '/_manager/_app/brands/create'
    | '/_manager/_app/campaigns/create'
    | '/_manager/_app/campaigns/reports'
    | '/_manager/_app/brands/'
    | '/_manager/_app/campaigns/'
    | '/_manager/_app/collaborations/'
    | '/_manager/_app/creators/'
    | '/_manager/_app/brands/$id/update'
    | '/_manager/_app/campaigns/$id/report'
    | '/_manager/_app/campaigns/$id/update'
    | '/_manager/_app/collaborations/$id/messages'
    | '/_manager/_app/campaigns/$id/'
    | '/_manager/_app/collaborations/$id/'
    | '/_manager/_app/creators/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  GuestRoute: typeof GuestRouteWithChildren
  ManagerRoute: typeof ManagerRouteWithChildren
  NotFoundRoute: typeof NotFoundRoute
  ImpersonateTokenRoute: typeof ImpersonateTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_manager': {
      id: '/_manager'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ManagerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof GuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate/$token': {
      id: '/impersonate/$token'
      path: '/impersonate/$token'
      fullPath: '/impersonate/$token'
      preLoaderRoute: typeof ImpersonateTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_manager/verify-updated-email': {
      id: '/_manager/verify-updated-email'
      path: '/verify-updated-email'
      fullPath: '/verify-updated-email'
      preLoaderRoute: typeof ManagerVerifyUpdatedEmailRouteImport
      parentRoute: typeof ManagerRoute
    }
    '/_manager/settings': {
      id: '/_manager/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ManagerSettingsRouteImport
      parentRoute: typeof ManagerRoute
    }
    '/_manager/logout': {
      id: '/_manager/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof ManagerLogoutRouteImport
      parentRoute: typeof ManagerRoute
    }
    '/_manager/customer-portal': {
      id: '/_manager/customer-portal'
      path: '/customer-portal'
      fullPath: '/customer-portal'
      preLoaderRoute: typeof ManagerCustomerPortalRouteImport
      parentRoute: typeof ManagerRoute
    }
    '/_manager/admin': {
      id: '/_manager/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof ManagerAdminRouteImport
      parentRoute: typeof ManagerRoute
    }
    '/_manager/_setup': {
      id: '/_manager/_setup'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ManagerSetupRouteImport
      parentRoute: typeof ManagerRoute
    }
    '/_manager/_app': {
      id: '/_manager/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ManagerAppRouteImport
      parentRoute: typeof ManagerRoute
    }
    '/_guest/verify-email': {
      id: '/_guest/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof GuestVerifyEmailRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/register': {
      id: '/_guest/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof GuestRegisterRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/recover-password': {
      id: '/_guest/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof GuestRecoverPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/login': {
      id: '/_guest/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof GuestLoginRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/forgot-password': {
      id: '/_guest/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof GuestForgotPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_manager/_app/': {
      id: '/_manager/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ManagerAppIndexRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_setup/subscription-past-due': {
      id: '/_manager/_setup/subscription-past-due'
      path: '/subscription-past-due'
      fullPath: '/subscription-past-due'
      preLoaderRoute: typeof ManagerSetupSubscriptionPastDueRouteImport
      parentRoute: typeof ManagerSetupRoute
    }
    '/_manager/_setup/create-first-brand': {
      id: '/_manager/_setup/create-first-brand'
      path: '/create-first-brand'
      fullPath: '/create-first-brand'
      preLoaderRoute: typeof ManagerSetupCreateFirstBrandRouteImport
      parentRoute: typeof ManagerSetupRoute
    }
    '/_manager/_setup/choose-subscription': {
      id: '/_manager/_setup/choose-subscription'
      path: '/choose-subscription'
      fullPath: '/choose-subscription'
      preLoaderRoute: typeof ManagerSetupChooseSubscriptionRouteImport
      parentRoute: typeof ManagerSetupRoute
    }
    '/_manager/_app/subscription': {
      id: '/_manager/_app/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof ManagerAppSubscriptionRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/creators/': {
      id: '/_manager/_app/creators/'
      path: '/creators'
      fullPath: '/creators'
      preLoaderRoute: typeof ManagerAppCreatorsIndexRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/collaborations/': {
      id: '/_manager/_app/collaborations/'
      path: '/collaborations'
      fullPath: '/collaborations'
      preLoaderRoute: typeof ManagerAppCollaborationsIndexRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/campaigns/': {
      id: '/_manager/_app/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof ManagerAppCampaignsIndexRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/brands/': {
      id: '/_manager/_app/brands/'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof ManagerAppBrandsIndexRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/campaigns/reports': {
      id: '/_manager/_app/campaigns/reports'
      path: '/campaigns/reports'
      fullPath: '/campaigns/reports'
      preLoaderRoute: typeof ManagerAppCampaignsReportsRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/campaigns/create': {
      id: '/_manager/_app/campaigns/create'
      path: '/campaigns/create'
      fullPath: '/campaigns/create'
      preLoaderRoute: typeof ManagerAppCampaignsCreateRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/brands/create': {
      id: '/_manager/_app/brands/create'
      path: '/brands/create'
      fullPath: '/brands/create'
      preLoaderRoute: typeof ManagerAppBrandsCreateRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/creators/$id/': {
      id: '/_manager/_app/creators/$id/'
      path: '/creators/$id'
      fullPath: '/creators/$id'
      preLoaderRoute: typeof ManagerAppCreatorsIdIndexRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/collaborations/$id/': {
      id: '/_manager/_app/collaborations/$id/'
      path: '/collaborations/$id'
      fullPath: '/collaborations/$id'
      preLoaderRoute: typeof ManagerAppCollaborationsIdIndexRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/campaigns/$id/': {
      id: '/_manager/_app/campaigns/$id/'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id'
      preLoaderRoute: typeof ManagerAppCampaignsIdIndexRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/collaborations/$id/messages': {
      id: '/_manager/_app/collaborations/$id/messages'
      path: '/collaborations/$id/messages'
      fullPath: '/collaborations/$id/messages'
      preLoaderRoute: typeof ManagerAppCollaborationsIdMessagesRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/campaigns/$id/update': {
      id: '/_manager/_app/campaigns/$id/update'
      path: '/campaigns/$id/update'
      fullPath: '/campaigns/$id/update'
      preLoaderRoute: typeof ManagerAppCampaignsIdUpdateRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/campaigns/$id/report': {
      id: '/_manager/_app/campaigns/$id/report'
      path: '/campaigns/$id/report'
      fullPath: '/campaigns/$id/report'
      preLoaderRoute: typeof ManagerAppCampaignsIdReportRouteImport
      parentRoute: typeof ManagerAppRoute
    }
    '/_manager/_app/brands/$id/update': {
      id: '/_manager/_app/brands/$id/update'
      path: '/brands/$id/update'
      fullPath: '/brands/$id/update'
      preLoaderRoute: typeof ManagerAppBrandsIdUpdateRouteImport
      parentRoute: typeof ManagerAppRoute
    }
  }
}

interface GuestRouteChildren {
  GuestForgotPasswordRoute: typeof GuestForgotPasswordRoute
  GuestLoginRoute: typeof GuestLoginRoute
  GuestRecoverPasswordRoute: typeof GuestRecoverPasswordRoute
  GuestRegisterRoute: typeof GuestRegisterRoute
  GuestVerifyEmailRoute: typeof GuestVerifyEmailRoute
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestForgotPasswordRoute: GuestForgotPasswordRoute,
  GuestLoginRoute: GuestLoginRoute,
  GuestRecoverPasswordRoute: GuestRecoverPasswordRoute,
  GuestRegisterRoute: GuestRegisterRoute,
  GuestVerifyEmailRoute: GuestVerifyEmailRoute,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

interface ManagerAppRouteChildren {
  ManagerAppSubscriptionRoute: typeof ManagerAppSubscriptionRoute
  ManagerAppIndexRoute: typeof ManagerAppIndexRoute
  ManagerAppBrandsCreateRoute: typeof ManagerAppBrandsCreateRoute
  ManagerAppCampaignsCreateRoute: typeof ManagerAppCampaignsCreateRoute
  ManagerAppCampaignsReportsRoute: typeof ManagerAppCampaignsReportsRoute
  ManagerAppBrandsIndexRoute: typeof ManagerAppBrandsIndexRoute
  ManagerAppCampaignsIndexRoute: typeof ManagerAppCampaignsIndexRoute
  ManagerAppCollaborationsIndexRoute: typeof ManagerAppCollaborationsIndexRoute
  ManagerAppCreatorsIndexRoute: typeof ManagerAppCreatorsIndexRoute
  ManagerAppBrandsIdUpdateRoute: typeof ManagerAppBrandsIdUpdateRoute
  ManagerAppCampaignsIdReportRoute: typeof ManagerAppCampaignsIdReportRoute
  ManagerAppCampaignsIdUpdateRoute: typeof ManagerAppCampaignsIdUpdateRoute
  ManagerAppCollaborationsIdMessagesRoute: typeof ManagerAppCollaborationsIdMessagesRoute
  ManagerAppCampaignsIdIndexRoute: typeof ManagerAppCampaignsIdIndexRoute
  ManagerAppCollaborationsIdIndexRoute: typeof ManagerAppCollaborationsIdIndexRoute
  ManagerAppCreatorsIdIndexRoute: typeof ManagerAppCreatorsIdIndexRoute
}

const ManagerAppRouteChildren: ManagerAppRouteChildren = {
  ManagerAppSubscriptionRoute: ManagerAppSubscriptionRoute,
  ManagerAppIndexRoute: ManagerAppIndexRoute,
  ManagerAppBrandsCreateRoute: ManagerAppBrandsCreateRoute,
  ManagerAppCampaignsCreateRoute: ManagerAppCampaignsCreateRoute,
  ManagerAppCampaignsReportsRoute: ManagerAppCampaignsReportsRoute,
  ManagerAppBrandsIndexRoute: ManagerAppBrandsIndexRoute,
  ManagerAppCampaignsIndexRoute: ManagerAppCampaignsIndexRoute,
  ManagerAppCollaborationsIndexRoute: ManagerAppCollaborationsIndexRoute,
  ManagerAppCreatorsIndexRoute: ManagerAppCreatorsIndexRoute,
  ManagerAppBrandsIdUpdateRoute: ManagerAppBrandsIdUpdateRoute,
  ManagerAppCampaignsIdReportRoute: ManagerAppCampaignsIdReportRoute,
  ManagerAppCampaignsIdUpdateRoute: ManagerAppCampaignsIdUpdateRoute,
  ManagerAppCollaborationsIdMessagesRoute:
    ManagerAppCollaborationsIdMessagesRoute,
  ManagerAppCampaignsIdIndexRoute: ManagerAppCampaignsIdIndexRoute,
  ManagerAppCollaborationsIdIndexRoute: ManagerAppCollaborationsIdIndexRoute,
  ManagerAppCreatorsIdIndexRoute: ManagerAppCreatorsIdIndexRoute,
}

const ManagerAppRouteWithChildren = ManagerAppRoute._addFileChildren(
  ManagerAppRouteChildren,
)

interface ManagerSetupRouteChildren {
  ManagerSetupChooseSubscriptionRoute: typeof ManagerSetupChooseSubscriptionRoute
  ManagerSetupCreateFirstBrandRoute: typeof ManagerSetupCreateFirstBrandRoute
  ManagerSetupSubscriptionPastDueRoute: typeof ManagerSetupSubscriptionPastDueRoute
}

const ManagerSetupRouteChildren: ManagerSetupRouteChildren = {
  ManagerSetupChooseSubscriptionRoute: ManagerSetupChooseSubscriptionRoute,
  ManagerSetupCreateFirstBrandRoute: ManagerSetupCreateFirstBrandRoute,
  ManagerSetupSubscriptionPastDueRoute: ManagerSetupSubscriptionPastDueRoute,
}

const ManagerSetupRouteWithChildren = ManagerSetupRoute._addFileChildren(
  ManagerSetupRouteChildren,
)

interface ManagerRouteChildren {
  ManagerAppRoute: typeof ManagerAppRouteWithChildren
  ManagerSetupRoute: typeof ManagerSetupRouteWithChildren
  ManagerAdminRoute: typeof ManagerAdminRoute
  ManagerCustomerPortalRoute: typeof ManagerCustomerPortalRoute
  ManagerLogoutRoute: typeof ManagerLogoutRoute
  ManagerSettingsRoute: typeof ManagerSettingsRoute
  ManagerVerifyUpdatedEmailRoute: typeof ManagerVerifyUpdatedEmailRoute
}

const ManagerRouteChildren: ManagerRouteChildren = {
  ManagerAppRoute: ManagerAppRouteWithChildren,
  ManagerSetupRoute: ManagerSetupRouteWithChildren,
  ManagerAdminRoute: ManagerAdminRoute,
  ManagerCustomerPortalRoute: ManagerCustomerPortalRoute,
  ManagerLogoutRoute: ManagerLogoutRoute,
  ManagerSettingsRoute: ManagerSettingsRoute,
  ManagerVerifyUpdatedEmailRoute: ManagerVerifyUpdatedEmailRoute,
}

const ManagerRouteWithChildren =
  ManagerRoute._addFileChildren(ManagerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  GuestRoute: GuestRouteWithChildren,
  ManagerRoute: ManagerRouteWithChildren,
  NotFoundRoute: NotFoundRoute,
  ImpersonateTokenRoute: ImpersonateTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
